import { useState } from "react";
import { MdWifiCalling3 } from "react-icons/md";
import { IoMail } from "react-icons/io5";

const inputClass =
  "w-full bg-[#f0ebe3] text-gray-700 text-sm px-4 py-3.5 rounded-xl outline-none placeholder-gray-400 border border-transparent focus:border-[#e8341c] transition-colors duration-200 resize-none";

export default function MinemoContact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    zip: "",
    service: "",
    message: "",
  });

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  return (
    <div
      className="w-full py-10 sm:py-12 px-4 sm:px-8"
      style={{
        background: "#faf7f2",
        fontFamily: "'Barlow', 'Montserrat', sans-serif",
      }}
    >
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-16 items-start">
        {/* ── Left column ── */}
        <div className="flex-1 max-w-md">
          {/* Label */}
          <span
            className="text-xs font-bold tracking-[0.22em] text-gray-800 uppercase"
            style={{ borderBottom: "2px solid #e8341c", paddingBottom: "3px" }}
          >
            LOCATIONS
          </span>

          {/* Heading */}
          <h2
            className="mt-5 text-gray-900 font-extrabold leading-tight"
            style={{
              fontSize: "clamp(30px, 4vw, 50px)",
              letterSpacing: "-0.02em",
            }}
          >
            Let's talk with
            <br />
            expertise
          </h2>

          {/* Subtext */}
          <p
            className="mt-5 text-gray-500 text-sm leading-relaxed"
            style={{ maxWidth: "380px" }}
          >
            Ultimately, the success of business is based on providing our
            customers with unparalleled product, service & support.
          </p>

          {/* Social links */}
          <div className=" mt-8 ">
            <div className="flex items-center gap-3">
              <i className=" ">
                <MdWifiCalling3
                  size={45}
                  className="bg-orange-200 p-3 rounded-full"
                />
              </i>
              <p className="text-sm font-krona font-semibold">
                {" "}
                Phone - +91 977 777 4005
              </p>
            </div>
            <div className="flex items-center gap-3 mt-4">
              <i className=" ">
                <IoMail size={45} className="bg-orange-200 p-3 rounded-full" />
              </i>
              <p className="text-sm font-krona font-semibold">
                {" "}
                Mail - headoffice@prudenceindia.com
              </p>
            </div>
          </div>
        </div>

        {/* Vertical divider */}
        <div className="hidden lg:block w-px self-stretch bg-gray-200" />

        {/* ── Right column — Form ── */}
        <div className="flex-1 w-full max-w-xl">
          <h3
            className="text-gray-900 font-extrabold mb-7"
            style={{ fontSize: "clamp(22px, 2.5vw, 30px)" }}
          >
            Request an Estimate
          </h3>

          <div className="flex flex-col gap-4">
            {/* Row 1 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input
                name="name"
                value={form.name}
                onChange={handle}
                placeholder="Your name*"
                className={inputClass}
              />
              <input
                name="email"
                type="email"
                value={form.email}
                onChange={handle}
                placeholder="Email address*"
                className={inputClass}
              />
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input
                name="phone"
                value={form.phone}
                onChange={handle}
                placeholder="Phone number*"
                className={inputClass}
              />
              <input
                name="zip"
                value={form.zip}
                onChange={handle}
                placeholder="Zip code*"
                className={inputClass}
              />
            </div>

            {/* Service */}
            <input
              name="service"
              value={form.service}
              onChange={handle}
              placeholder="Service*"
              className={inputClass}
            />

            {/* Message */}
            <textarea
              name="message"
              value={form.message}
              onChange={handle}
              placeholder="Your message here*"
              rows={5}
              className={inputClass}
            />

            {/* Submit row */}
            <div className="flex items-center gap-5 flex-wrap mt-1">
              <button
                onClick={() => {
                  alert("We Will Contact You Shortly");
                  setForm({
                    name: "",
                    email: "",
                    phone: "",
                    zip: "",
                    service: "",
                    message: "",
                  });
                }}
                className="bg-[#e8341c] hover:bg-[#c42b14] text-white text-xs font-black tracking-[0.18em] uppercase px-8 py-4 rounded transition-colors duration-200"
                style={{ letterSpacing: "0.14em" }}
              >
                GET ESTIMATE
              </button>
              <p className="text-gray-500 text-sm">
                Been here before?{" "}
                <a
                  href="tel:+919777774005"
                  className="text-gray-800 font-semibold underline underline-offset-2 hover:text-[#e8341c] transition-colors duration-200"
                >
                  Call Us
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
